 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"dashboard-dashboard-module-ngfactory":"dashboard-dashboard-module-ngfactory","default~admin-admin-module-ngfactory~auth-auth-module-ngfactory~buysell-buysell-module-ngfactory~com~cd68a0c9":"default~admin-admin-module-ngfactory~auth-auth-module-ngfactory~buysell-buysell-module-ngfactory~com~cd68a0c9","common":"common","auth-auth-module-ngfactory":"auth-auth-module-ngfactory","default~admin-admin-module-ngfactory~blacklist-blacklist-module-ngfactory~buysell-buysell-module-ngf~d3b324c9":"default~admin-admin-module-ngfactory~blacklist-blacklist-module-ngfactory~buysell-buysell-module-ngf~d3b324c9","default~admin-admin-module-ngfactory~companies-companies-module-ngfactory~customer-list-customer-lis~be025d3e":"default~admin-admin-module-ngfactory~companies-companies-module-ngfactory~customer-list-customer-lis~be025d3e","default~details-customer-details-customer-module-ngfactory~transaction-history-transaction-history-m~266925ba":"default~details-customer-details-customer-module-ngfactory~transaction-history-transaction-history-m~266925ba","details-customer-details-customer-module-ngfactory":"details-customer-details-customer-module-ngfactory","default~admin-admin-module-ngfactory~buysell-buysell-module-ngfactory~companies-companies-module-ngf~aea197df":"default~admin-admin-module-ngfactory~buysell-buysell-module-ngfactory~companies-companies-module-ngf~aea197df","moneytransfer-status-moneytransfer-status-module-ngfactory":"moneytransfer-status-moneytransfer-status-module-ngfactory","settings-settings-module-ngfactory":"settings-settings-module-ngfactory","default~admin-admin-module-ngfactory~buysell-buysell-module-ngfactory~companies-companies-module-ngf~f55af99f":"default~admin-admin-module-ngfactory~buysell-buysell-module-ngfactory~companies-companies-module-ngf~f55af99f","default~admin-admin-module-ngfactory~buysell-buysell-module-ngfactory~customer-transaction-customer-~cb4a0258":"default~admin-admin-module-ngfactory~buysell-buysell-module-ngfactory~customer-transaction-customer-~cb4a0258","default~admin-admin-module-ngfactory~buysell-buysell-module-ngfactory~customer-transaction-customer-~256bf709":"default~admin-admin-module-ngfactory~buysell-buysell-module-ngfactory~customer-transaction-customer-~256bf709","default~admin-admin-module-ngfactory~buysell-buysell-module-ngfactory":"default~admin-admin-module-ngfactory~buysell-buysell-module-ngfactory","buysell-buysell-module-ngfactory":"buysell-buysell-module-ngfactory","default~companies-companies-module-ngfactory~customer-transaction-customer-transaction-module-ngfact~cd5b1566":"default~companies-companies-module-ngfactory~customer-transaction-customer-transaction-module-ngfact~cd5b1566","default~admin-admin-module-ngfactory~customer-transaction-customer-transaction-module-ngfactory~news~50fc7493":"default~admin-admin-module-ngfactory~customer-transaction-customer-transaction-module-ngfactory~news~50fc7493","default~customer-transaction-customer-transaction-module-ngfactory~transaction-history-transaction-h~24771a21":"default~customer-transaction-customer-transaction-module-ngfactory~transaction-history-transaction-h~24771a21","customer-transaction-customer-transaction-module-ngfactory":"customer-transaction-customer-transaction-module-ngfactory","default~admin-admin-module-ngfactory~companies-companies-module-ngfactory~customer-list-customer-lis~d7cfa138":"default~admin-admin-module-ngfactory~companies-companies-module-ngfactory~customer-list-customer-lis~d7cfa138","default~admin-admin-module-ngfactory~newspaper-newspaper-module-ngfactory":"default~admin-admin-module-ngfactory~newspaper-newspaper-module-ngfactory","default~admin-admin-module-ngfactory~blacklist-blacklist-module-ngfactory":"default~admin-admin-module-ngfactory~blacklist-blacklist-module-ngfactory","admin-admin-module-ngfactory":"admin-admin-module-ngfactory","newspaper-newspaper-module-ngfactory":"newspaper-newspaper-module-ngfactory","default~companies-companies-module-ngfactory~customer-list-customer-list-module-ngfactory~transactio~5eed71e7":"default~companies-companies-module-ngfactory~customer-list-customer-list-module-ngfactory~transactio~5eed71e7","transaction-list-transaction-list-module-ngfactory":"transaction-list-transaction-list-module-ngfactory","default~reports-reports-module-ngfactory~transactions-transactions-module-ngfactory":"default~reports-reports-module-ngfactory~transactions-transactions-module-ngfactory","transactions-transactions-module-ngfactory":"transactions-transactions-module-ngfactory","customer-list-customer-list-module-ngfactory":"customer-list-customer-list-module-ngfactory","companies-companies-module-ngfactory":"companies-companies-module-ngfactory","transaction-history-transaction-history-module-ngfactory":"transaction-history-transaction-history-module-ngfactory","default~payment-place-payment-place-module-ngfactory~users-users-module-ngfactory":"default~payment-place-payment-place-module-ngfactory~users-users-module-ngfactory","users-users-module-ngfactory":"users-users-module-ngfactory","system-owner-system-owner-module-ngfactory":"system-owner-system-owner-module-ngfactory","payment-place-payment-place-module-ngfactory":"payment-place-payment-place-module-ngfactory","blacklist-blacklist-module-ngfactory":"blacklist-blacklist-module-ngfactory","debit-credit-debit-credit-module-ngfactory":"debit-credit-debit-credit-module-ngfactory","reports-reports-module-ngfactory":"reports-reports-module-ngfactory"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
